var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSyncswap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 107.5 147.1",
    enableBackground: "new 0 0 107.5 147.1",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.24428e-7,
    y1: 73.5594,
    x2: 107.5046,
    y2: 73.5594
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A99FFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D076FF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M107.4,44.6c0.6,6.1-0.7,12-3.3,17.5c-0.8,1.7-0.3,2.6,0.5,4c2.4,4.3,1.5,7.6-2.8,9.9 c-5.4,2.9-10.9,5.8-16.4,8.5c-2,1-2.7,1.8-1.5,4.1c12.5,25.3-6.9,51.8-31,57.4c-22.4,5.2-45.5-9.4-51.3-31.5 c-2.6-9.8-2-19.1,1.5-28.4c0.6-1.6,0.8-2.9,0-4.7c-2.2-4.6-1.2-7.5,3.3-9.9c4.8-2.6,9.7-5.2,14.7-7.4c2.6-1.2,2.8-2.5,1.7-4.9 c-9.5-21.6,3.5-43.1,21.4-53.6c27.6-16.1,58,5.2,62.5,28.6C107.4,37.7,107.2,41.1,107.4,44.6z M100.4,69.7 c-5.8-1.9-5.1-4.5-3.3-7.9c2.5-4.7,4.3-9.9,4.4-15.2c0.5-31.8-31.4-48.8-54.4-35.2C24.8,24.5,18,50.9,38,69.7 C44.7,76,52.7,80.4,60,85.9c7,5.3,12.2,12.2,10.9,21.1c-1.9,13.7-17.5,25.5-31.7,22.7c-21-4.2-26.5-26.2-19.4-40 c1.2-2.2,2.4-3.7,4.9-1.5c1.8,1.5,2.9,1.3,3-1.4c0.1-5.5,0.4-11,0.7-16.5c0.1-2.3-0.6-2.8-2.5-1.8c-5.7,3-11.4,5.9-17.8,9.3 c5,2,4.2,4.2,2.4,7.9c-6.5,13.4-4.7,26.6,3.1,38.8c12.2,19,41.8,21.5,58.5,2.6c6.2-7,9.2-15.1,8.9-24c-0.4-10.5-6.5-18.4-14.1-25.4 c-6.7-6.2-15.3-9.6-21.3-17c-10.2-12.5-10-24.5,2.1-35.4c9.6-8.6,22.5-9,32.4-1c9.6,7.8,12.4,21.9,6.4,32.5c-1,1.8-1.8,3.9-4.4,1.7 c-1.2-0.9-2.3-0.8-2.3,1c-0.3,6.1-0.5,12.3-0.7,18.4c-0.1,1.9,0.7,2.4,2.4,1.5C87.3,76.3,93.3,73.3,100.4,69.7z M34.6,75.2 c-0.3,5.7-0.4,10-0.7,14.2c-0.3,3.9-2.3,6.7-6.6,6.6c-2.2-0.1-2.8,0.7-3.2,2.6c-2.1,10.2,3.8,20.6,13.6,23.6 c9.3,2.9,19.6-1.5,24.5-10.5c3.6-6.6,1.9-14.6-4.8-20C50.3,86.2,42.1,82.1,34.6,75.2z M72.7,73.6c0.2-5.4,0.5-9.8,0.6-14.3 c0.1-3.7,1.5-6.8,5.2-7.6c4-0.8,4.6-3.3,4.6-6.5c0.2-7.8-4.8-15.9-11.6-18.9c-6.2-2.8-14.8-0.8-20.6,4.8 c-7.8,7.4-8.4,15.9-2.1,23.5C55.3,62.5,64.5,66.5,72.7,73.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncswap);
export default __webpack_public_path__ + "static/media/syncswap.8104cce99561e5c4b5a4474ce615286b.svg";
export { ForwardRef as ReactComponent };